import { useState } from "react";
import Pencil from "../../assets/img/pencil.svg";
import TableCheckbox from "./TableCheckbox";
import EditarPersona from "../AcreditacionesNoVerificados/EditarPersona";
const AcreditacionesCard = ({
  periodista,
  selectedPeriodistas,
  setSelectedPeriodistas,
  isVerificado,
  maxPreacreditados
}) => {
  const [checked, setChecked] = useState(false);

  const [currentPeriodista, setCurrentPeriodista] = useState(periodista);
  const [editOpen, setEditOpen] = useState(false);

  const handleChange = (event) => {
    const periodistasCopia = [...selectedPeriodistas];
    if (!checked) {
      if (selectedPeriodistas.length >= maxPreacreditados) return;
      periodistasCopia.push(currentPeriodista);
      setChecked(true);
    } else {
      const index = periodistasCopia.indexOf(currentPeriodista);
      periodistasCopia.splice(index, 1);
      setChecked(false);
    }
    setSelectedPeriodistas(periodistasCopia);
  };

  const handleEditOpen = () => {
    setEditOpen((prevState) => !prevState);
  };

  return (
    <div className={`acreditaciones-card ${checked ? "active" : ""}`}>
      <div className="acreditaciones-flex">
        <div className="acr-card-data">
          <div>
            <h5>{currentPeriodista.nombre}</h5>
            <p>{currentPeriodista.cargo}</p>
          </div>
          <span>DNI: {currentPeriodista.dni}</span>
          <span>{currentPeriodista.mail}</span>
          <span>{currentPeriodista.celular}</span>
        </div>
        <div className="td-checkbox">
          <TableCheckbox
            isChecked={checked}
            value={currentPeriodista}
            onClick={handleChange}
          />
        </div>
      </div>
      {!isVerificado && (
        <>
          <div className="icono-texto" onClick={handleEditOpen}>
            <img src={Pencil} alt="Editar" />
            <p>Editar</p>
          </div>
          <EditarPersona
            periodista={currentPeriodista}
            setPeriodista={setCurrentPeriodista}
            isOpen={editOpen}
            setIsOpen={setEditOpen}
          />
        </>
      )}
    </div>
  );
};

export default AcreditacionesCard;
